import React, { useState, useEffect } from 'react';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';
import EditIcon from 'Assets/icons/edit.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function AdminUserGuideSection(props) {
    const [showContent, setShowContent] = useState(false);
    const [editUrl, setEditUrl] = useState(props.editUrl);

    useEffect(() => {
        const url = props.editUrl.replace('INSTRUCTION_ID', props.item.id);
        setEditUrl(url);
    }, []);

    const toggle = () => {
        setShowContent(!showContent);
    };

    const edit = () => {
        window.location.href = editUrl;
    };

    return (
        <div className="my-1">
            <div className={'card bg-white border-0 rounded-15px py-0 shadow'}>
                <div
                    className="card-header d-flex justify-content-between px-4"
                    style={{
                        borderTopLeftRadius: '15px',
                        borderTopRightRadius: '15px',
                        borderBottomLeftRadius: showContent ? '0' : '15px',
                        borderBottomRightRadiusRadius: showContent ? '0' : '15px',
                    }}
                >
                    <div className="d-flex">
                        <h4 className="text-center text-blue tw-cursor-pointer" onClick={toggle}>
                            {props.item.section}
                        </h4>
                        {props.isCategory && (
                            <div className="tw-pl-2 tw-flex tw-items-center tw-cursor-pointer" onClick={props.toggleExpanded}>
                                {props.expanded && <ChevronUpIcon className="tw-h-3 tw-w-3 tw-mx-auto tw-my-auto" />}
                                {!props.expanded && <ChevronDownIcon className="tw-h-3 tw-w-3 tw-mx-auto tw-my-auto" />}
                            </div>
                        )}
                    </div>
                    <div className="d-flex">
                        <div className="tw-cursor-pointer p-2" onClick={edit}>
                            <EditIcon className="tw-w-3 tw-h-3" />
                        </div>
                        <div className="tw-cursor-pointer p-2" onClick={toggle}>
                            {showContent ? <ChevronUpIcon className="tw-w-2.5 tw-h-2.5" /> : <ChevronDownIcon className="tw-w-2.5 tw-h-2.5" />}
                        </div>
                        <div className="ml-5 tw-cursor-pointer p-2" onClick={props.deleteHandler}>
                            <TrashIcon className="tw-w-3 tw-h-3 tw-text-red" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <div className={`card bg-white border-0 rounded-15px py-2 shadow ${showContent ? '' : 'hidden'}`}>
                    <div className="px-4" dangerouslySetInnerHTML={{ __html: props.item.content }} />
                </div>
            </div>
        </div>
    );
}
